module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.scss
// module id = ./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.scss
// module chunks = 0